export interface CsvUidModel {
	StaffNumber: string;
	DistrictCode: string;
	EmployeeNumber: string;
}

export interface CsvBudgetModel {
	AccountNumber: string;
	Amount: string;
}

export interface CsvJournalModel {
	AccountNumber: string;
	Description: string;
	DebitAmount: number;
	CreditAmount: number;
}

export interface CsvAchModel {
	ReferenceNumber: string;
	SiteCode: string;
	OriginalAccountNumber: string;
	AccountNumber: string;
	AccountDescription: string;
	DepositDT: string;
	Amount: string;
}

export class CsvReader {
	public static readUid = (fileContent: string): CsvUidModel[] => {
		const lines = fileContent.split('\n');
		const values: CsvUidModel[] = [];

		for (const line of lines) {
			const data = line.split(',');
			if (data[0]) {
				values.push({
					StaffNumber: data[0],
					DistrictCode: data[2],
					EmployeeNumber: data[9],
				});
			}
		}

		return values;
	};

	public static readBudget = (fileContent: string): CsvBudgetModel[] => {
		const lines = fileContent.replace(/[\r]+/g, '').split('\n');
		const values: CsvBudgetModel[] = [];

		for (let i = 1; i < lines.length; i++) {
			const data = lines[i].split(',');
			if (data[0]) {
				values.push({
					AccountNumber: data[0],
					Amount: data[1],
				});
			}
		}

		return values;
	};

	public static readJournal = (fileContent: string): CsvJournalModel[] => {
		const lines = fileContent.split('\n');
		const values: CsvJournalModel[] = [];

		for (let i = 1; i < lines.length; i++) {
			const data = lines[i].split(',');
			if (data[0]) {
				values.push({
					AccountNumber: data[0],
					Description: data[1],
					DebitAmount: Number(data[2]),
					CreditAmount: Number(data[3]),
				});
			}
		}

		return values;
	};

	public static readAch = (fileContent: string): CsvAchModel[] => {
		const lines = fileContent.split('\n');
		const values: CsvAchModel[] = [];

		for (let i = 1; i < lines.length; i++) {
			const data = lines[i].split(',');
			if (data[0]) {
				values.push({
					ReferenceNumber: data[0],
					SiteCode: data[1],
					OriginalAccountNumber: data[2],
					AccountNumber: data[2],
					AccountDescription: data[3],
					DepositDT: data[4],
					Amount: data[5],
				});
			}
		}

		return values;
	};
}
